"use strict";

var xxxx = 12;